/**
 * Advanced markers require a vector map, which in turn requires a map id.
 * `DEMO_MAP_ID` is Google's reserved id for trying advanced markers without
 * creating a cloud-based map style; it renders the default (red) marker.
 */
export const MAP_ID = 'DEMO_MAP_ID'
